// import React, { useEffect, useState } from 'react';
// import { Controller, useForm } from 'react-hook-form';
// import { Button, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
// import ErrorMessage from './ErrorMessage';

// const InvoiceIssueModal = ({ isOpen, onClose, invoiceNumber, invoiceId, clientName, clientId, onSubmit, loading }) => {
//     const {
//         control,
//         handleSubmit,
//         setValue,
//         formState: { errors }
//     } = useForm();

//     useEffect(() => {
//         setValue("invoiceNumber", invoiceNumber || "");
//         setValue("clientName", clientName || "");
//         setValue("clientId", clientId || "");
//         setValue("issueDescription", "");
//     }, [isOpen, invoiceNumber, invoiceId, clientName, clientId, setValue]);

//     const submitForm = (data) => {
//         onSubmit(data);
//     };

//     return (
//         <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
//             <ModalHeader toggle={onClose} className='header_modal align-items-center'>
//                 <h5 className="modal-title_u">Report Invoice Issue</h5>
//             </ModalHeader>
//             <ModalBody className='modal_form_body'>
//                     <div className="step_cards step_4">
//                         <div className="row-primary">
//                             <h2>Invoice Number</h2>
                
//                             <div style={{ width: "100%" }}>
//                                 <Controller
//                                     name="invoiceNumber"
//                                     control={control}
//                                     render={({ field }) => (
//                                         <input
//                                             {...field}
//                                             type="text"
//                                             className="input-in type_inp"
//                                             readOnly
//                                         />
//                                     )}
//                                 />
//                             </div>
//                         </div>

//                         <Controller
//                             name="clientId"
//                             control={control}
//                             render={({ field }) => (
//                                 <input
//                                     {...field}
//                                     type="hidden"
//                                 />
//                             )}
//                         />
//                         <div className="row-primary">
//                             <h2>Client Name</h2>

//                             <div style={{ width: "100%" }}>
//                                 <Controller
//                                     name="clientName"
//                                     control={control}
//                                     render={({ field }) => (
//                                         <input
//                                             {...field}
//                                             type="text"
//                                             className="input-in type_inp"
//                                             readOnly
//                                         />
//                                     )}
//                                 />
//                             </div>
//                         </div>

//                         <div className="row-primary">
//                             <h2>Issue Description *</h2>

//                             <div style={{ width: "100%" }}>
//                                 <Controller
//                                     name="issueDescription"
//                                     control={control}
//                                     rules={{
//                                         required: "Issue description is required."
//                                     }}
//                                     render={({ field }) => (
//                                         <textarea
//                                             {...field}
//                                             rows={5}
//                                             className="input-in type_inp"
//                                             placeholder="Describe the issue with this invoice"
//                                         />
//                                     )}
//                                 />

//                                 {errors?.issueDescription?.message && (
//                                     <div style={{ marginBottom: 10 }}>
//                                         <ErrorMessage text={errors.issueDescription.message} />
//                                     </div>
//                                 )}
//                             </div>
//                         </div>
//                     </div>
//             </ModalBody>
//             <ModalFooter>
//                 <Button
//                     className="main_button"
//                     onClick={handleSubmit(submitForm)}
//                     disabled={loading}
//                 >
//                     {loading ? "Submitting..." : "Submit"}
//                 </Button>

//                 <Button className="table_delete" onClick={onClose}>
//                     Cancel
//                 </Button>
//             </ModalFooter>
//         </Modal>
//     );
// };

// export default InvoiceIssueModal;

import React, { useEffect } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import ErrorMessage from './ErrorMessage';

const InvoiceIssueModal = ({
    isOpen,
    onClose,
    invoiceNumber,
    invoiceId,
    clientName,
    clientId,
    issueDescription,
    status,
    onSubmit,
    loading,
    mode = "create", // "create" | "update"
}) => {
    const { t } = useTranslation();
    const isUpdateMode = mode === "update";

    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm();

    useEffect(() => {
        setValue("invoiceId", invoiceId || "");
        setValue("invoiceNumber", invoiceNumber || "");
        setValue("clientName", clientName || "");
        setValue("clientId", clientId || "");
        setValue("issueDescription", issueDescription || "");
        setValue("status", status || "pending");
    }, [isOpen, invoiceNumber, invoiceId, clientName, clientId, issueDescription, status, setValue]);

    const submitForm = (data) => {
        if (isUpdateMode) {
            onSubmit({
                id: data.invoiceId,
                status: data.status,
            });
        } else {
            onSubmit(data);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
            <ModalHeader toggle={onClose} className='header_modal align-items-center'>
                <h5 className="modal-title_u">{isUpdateMode ? t('invoiceIssues.update') : t('invoiceIssues.report')} {t('invoiceIssues.invoiceIssue')}</h5>
            </ModalHeader>
            <ModalBody className='modal_form_body'>
                <Controller
                    name="invoiceId"
                    control={control}
                    render={({ field }) => (
                        <input {...field} type="hidden" />
                    )}
                />
                <Controller
                    name="clientId"
                    control={control}
                    render={({ field }) => (
                        <input {...field} type="hidden" />
                    )}
                />

                <div className="step_cards step_4">
                    <div className="row-primary">
                        <h2>{t('invoiceIssues.invoiceNumber')}</h2>
                        <div style={{ width: "100%" }}>
                            <Controller
                                name="invoiceNumber"
                                control={control}
                                render={({ field }) => (
                                    <input
                                        {...field}
                                        type="text"
                                        className="input-in type_inp"
                                        readOnly
                                    />
                                )}
                            />
                        </div>
                    </div>

                    {/* <div className="row-primary">
                        <h2>Client Name</h2>
                        <div style={{ width: "100%" }}>
                            <Controller
                                name="clientName"
                                control={control}
                                render={({ field }) => (
                                    <input
                                        {...field}
                                        type="text"
                                        className="input-in type_inp"
                                        readOnly
                                    />
                                )}
                            />
                        </div>
                    </div> */}

                    <div className="row-primary">
                        <h2>{t('invoiceIssues.issueDescription')} {!isUpdateMode && "*"}</h2>
                        <div style={{ width: "100%" }}>
                            <Controller
                                name="issueDescription"
                                control={control}
                                rules={
                                    !isUpdateMode
                                        ? { required: t('invoiceIssues.issueDescriptionRequired') }
                                        : {}
                                }
                                render={({ field }) => (
                                    <textarea
                                        {...field}
                                        rows={5}
                                        className="input-in type_inp"
                                        placeholder={t('invoiceIssues.issueDescriptionPlaceholder')}
                                        readOnly={isUpdateMode}
                                    />
                                )}
                            />

                            {errors?.issueDescription?.message && (
                                <div style={{ marginBottom: 10 }}>
                                    <ErrorMessage text={errors.issueDescription.message} />
                                </div>
                            )}
                        </div>
                    </div>

                    {isUpdateMode && (
                        <div className="row-primary">
                            <h2>{t('invoiceIssues.status')}</h2>
                            <div style={{ width: "100%" }}>
                                <Controller
                                    name="status"
                                    control={control}
                                    rules={{ required: t('invoiceIssues.statusRequired') }}
                                    render={({ field }) => (
                                        <select {...field} className="input-in type_inp">
                                            <option value="pending">{t('invoiceIssues.pending')}</option>
                                            <option value="resolved">{t('invoiceIssues.resolved')}</option>
                                            <option value="rejected">{t('invoiceIssues.rejected')}</option>
                                        </select>
                                    )}
                                />

                                {errors?.status?.message && (
                                    <div style={{ marginBottom: 10 }}>
                                        <ErrorMessage text={errors.status.message} />
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </ModalBody>
            <ModalFooter>
                <button
                    type="button"
                    className="main_button"
                    onClick={handleSubmit(submitForm)}
                    disabled={loading}
                >
                    {loading ? t('invoiceIssues.submitting') : t('invoiceIssues.submit')}
                </button>

                <button className="table_delete" onClick={onClose} type="button">
                    {t('common.cancel')}
                </button>
            </ModalFooter>
        </Modal>
    );
};

export default InvoiceIssueModal;